// extracted by mini-css-extract-plugin
module.exports = {"Loader":"Loader-module__Loader___33amu","spin":"Loader-module__spin___Qgcyl"};